import React from 'react';
import RefreshingChart from './RefreshingChart';

const GraphCheckinTimeGrow = ( props ) => {
	return (
		<RefreshingChart
			{ ...props }
			fetchMethod="fetchCheckinTimeGrow"
		/>
	);
};

export default GraphCheckinTimeGrow;
